exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#generate-temporary-qr-modal-portal .react-modal-body {\n  max-width: 600px;\n  width: 70%;\n  padding: 30px;\n}\n#generate-temporary-qr-modal-portal .generate-temporary-qr-select-time-table tbody tr td {\n  padding: 5px 2px;\n}\n#generate-temporary-qr-modal-portal .btm-pane {\n  text-align: right;\n  margin-top: 20px;\n}", ""]);

// exports
